import React, { useEffect, useState } from "react";
import { fetchAdvanceDirectiveArticles } from "../../api/educationalContentApi";

export default function AdvanceDirectiveArticles() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = await fetchAdvanceDirectiveArticles();
        setArticles(data);
      } catch (err) {
        console.error("Error fetching advance directive articles:", err);
      }
    };
    fetchArticles();
  }, []);

  if (!articles.length) return <div className="mb-2">No advance directive articles available.</div>;

  return (
    <section className="mb-6">
      <div className="flex gap-4 overflow-x-auto">
        {articles.map((article, index) => (
          <a
            key={index}
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="min-w-[250px] p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow"
          >
            <h4 className="font-bold text-[#04395b] mb-2">{getSourceName(article.url)}</h4>
            <p className="text-sm text-gray-600">{article.title}</p>
          </a>
        ))}
      </div>
    </section>
  );
}

function getSourceName(url) {
  try {
    const domain = new URL(url).hostname;
    if (domain.includes("mayoclinic")) return "Mayo Clinic";
    if (domain.includes("hopkinsmedicine")) return "Johns Hopkins Medicine";
    if (domain.includes("fivewishes")) return "Five Wishes Foundation";
    if (domain.includes("hss")) return "HSS";
    return domain.replace("www.", "");
  } catch {
    return "Source";
  }
}